import { BRAND_CONTACT } from "@/data/products";

// Floating WhatsApp button — visible on every page
const WhatsAppFAB = () => {
  return (
    <a
      href={`https://wa.me/${BRAND_CONTACT.whatsapp}?text=${encodeURIComponent(
        "Hola La Criollita, me gustaría más información sobre vuestros productos."
      )}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping group-hover:opacity-0 transition-opacity" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-lg shadow-black/20 transition-all hover:scale-105">
        {/* Official WhatsApp glyph */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7 md:w-8 md:h-8 fill-current"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.83 2.722.83.115 0 .226-.014.337-.025.39-.04.99-.155 1.318-.342.516-.287.7-.59.7-1.03 0-.46-.27-.65-.6-.85zM16.072 23.39h-.012c-1.79 0-3.578-.5-5.122-1.435l-.367-.218-3.778.99 1.018-3.685-.238-.378a10.085 10.085 0 0 1-1.548-5.376C6.025 7.92 10.541 3.41 16.07 3.41a10.131 10.131 0 0 1 7.21 2.987 10.116 10.116 0 0 1 2.984 7.21c-.014 5.582-4.535 10.094-10.118 10.094zm8.6-18.685a12.16 12.16 0 0 0-8.6-3.567C9.36 1.138 3.92 6.575 3.92 13.27c0 2.144.557 4.235 1.625 6.083L3.8 25.62l6.435-1.69a12.16 12.16 0 0 0 5.823 1.49h.006c6.69 0 12.13-5.438 12.13-12.13 0-3.24-1.275-6.286-3.553-8.585z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppFAB;
